import { alpha, keyframes } from "@mui/material";
import palette from "../../styles/light-theme/palette";

export const sxInputLogin = {
  "label + &": {
    marginTop: 2.5,
  },

  "& .MuiInputBase-root": {
    borderRadius: 2.5,
    backgroundColor: "#F3F6F9",
    border: "1px solid #E0E3E7",
    paddingRight: "8px",
    transition: "0.2s",

    "&:focus-within": {
      boxShadow: `${alpha(palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: palette.primary.main,
    },
  },
  "& .MuiInputBase-input": {
    fontSize: 12,
    padding: "0.8rem",
  },
};

export const float3D = keyframes`
    0% { 
      transform: translateY(0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg); 
      filter: drop-shadow(0px 5px 5px rgba(0,0,0,0.2));
    }
    33% {
      transform: translateY(-25px) rotateX(15deg) rotateY(-10deg) rotateZ(5deg);
      filter: drop-shadow(15px 25px 15px rgba(0,0,0,0.1));
    }
    66% {
      transform: translateY(-10px) rotateX(-10deg) rotateY(15deg) rotateZ(-5deg);
      filter: drop-shadow(-10px 15px 10px rgba(0,0,0,0.15));
    }
    100% { 
      transform: translateY(0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg);
      filter: drop-shadow(0px 5px 5px rgba(0,0,0,0.2));
    }
  `;
